export const addresses = {
  tokenGate:"0x534eB18Cb9C2D4035602f52bCCDD82edDbfcC838",
}
